import React from "react";

import StyledFooter from "./styles";

const Footer = ({buttons}) => {
  return <StyledFooter>{buttons}</StyledFooter>;
};

export default Footer;
